import { useLeaderboardContext } from '../contexts/LeaderboardContext';

// Re-export types from context for backward compatibility
export type { 
  RewardConfig, 
  RewardsConfiguration, 
  WeeklyLeaderboardResponse, 
  LeaderboardEntry, 
  UserStreakResponse 
} from '../contexts/LeaderboardContext';

/**
 * Hook to use leaderboard data with global state synchronization
 * @param isActive - Whether the hook should be active (for backward compatibility)
 * @returns Leaderboard data and utilities
 */
export const useLeaderboard = (isActive: boolean = true) => {
  const context = useLeaderboardContext();
  
  // For backward compatibility, if isActive is false, return null data
  if (!isActive) {
    return {
      ...context,
      data: null,
      userStreak: null,
      loading: false,
      error: null,
      getWeekDisplayString: '',
    };
  }
  
  return context;
};